// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components/lifestyle/lifestyle.component.scss
// module id = 396
// module chunks = 0